import { z } from 'zod';

export const GenericFilter = z.object({
  id: z.string(),
  name: z.string(),
  filterExpression: z.string(),
  dailyCounter: z.number(),
  globalCounter: z.number(),
  includedFiles: z.array(z.string()),
});

export const GenericAllowance = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().default(''),
  enabled: z.boolean(),
  startDate: z.string(),
  endDate: z.string(),
  globalLimit: z.number(),
  dailyLimit: z.number(),
  filters: z.array(GenericFilter),
});

/**
 * Generic allowances payload exchanged by tenant create/update/get endpoints.
 * Persisted as JSONB in tenant.barcoConfig.license.genericAllowances.
 */
export const GenericAllowancesPayload = z.array(GenericAllowance);
export type GenericAllowancesPayloadType = z.infer<typeof GenericAllowancesPayload>;
